import { useState, useEffect } from 'react';
import { Telemetry } from 'core/models/FMS/Telemetry';
import { Project } from 'core/models/project';
import { Vehicle } from 'core/models/vehicle';
import { useVehicleTelemetryRepository } from './useVehicleTelemetryRepository';

export function useVehicleTelemetry(vehicleId: Vehicle.Id, projectId: Project.Id) {
    const repository = useVehicleTelemetryRepository(projectId);

    const [telemetry, set] = useState<Telemetry>();

    useEffect(() => {
        if (!repository) return;

        repository.addTelemetryListener(vehicleId, set);

        return () => {
            repository.removeTelemetryListener(vehicleId, set);
        };
    }, [repository, vehicleId]);

    return telemetry;
}
